import Swal from "sweetalert2";
import api from "../../../utilities/interseptor";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API


export const getTipoUnidad = (setExcepciones) => {
    api.get(`${apiUrl}/monitor/excepciones/getTipoUnidad`).then((res) => {
        setExcepciones(res.data)

    })
        .catch((error) => {
            console.log("error", error);
        })
}
export const getProveedoresAliados = (setProveedores) => {
    api.get(`${apiUrl}/monitor/getAllProveedoresAliados`).then((res) => {
        const proveedoresMasSuma = [...res.data]
        proveedoresMasSuma.push({ name: "SUMA TE LLEVA", code: 1 })
        setProveedores(proveedoresMasSuma)

    })
        .catch((error) => {
            console.log("error", error);
        })
}
export const createNewExcepcion = (data,limpiar) => {
    Swal.fire({
        title: 'Cargando...',
        text: 'Obteniendo datos...',
        allowOutsideClick: false,  // Evita que el modal se cierre haciendo clic fuera
        allowEscapeKey: false,     // Evita que el modal se cierre con la tecla ESC
        didOpen: () => {
            Swal.showLoading();     // Muestra el spinner de carga
        }
    })
    api.post(`${apiUrl}/monitor/programacion/excepciones`, data).then((res) => {
        Swal.close();
        if(res.data.message)
        {
            Swal.fire({
                icon: 'error',   // Icono de error
                text:res.data.message ,
                confirmButtonText: 'OK'  // Texto del botón de confirmación
            });
        }
        else{
            Swal.fire({
                icon: 'success',   // Icono de error
                text: 'Se agrego la excepción con exito BITACORA: ' + res.data.BITACORAS.map((bitacora) => {return bitacora}), // Mensaje de error
                confirmButtonText: 'OK'  // Texto del botón de confirmación
            });
            limpiar()
        }
    })
        .catch((error) => {
            Swal.close();
            Swal.fire({
                icon: 'error',   // Icono de error
                text: error,
                confirmButtonText: 'OK'  // Texto del botón de confirmación
            });
            console.log("error", error);



        })


}